import React from "react";
import ArrowForwardRoundedIcon from "@material-ui/icons/ArrowForwardRounded";
import ArrowBackRoundedIcon from "@material-ui/icons/ArrowBackRounded";
import StorefrontOutlinedIcon from "@material-ui/icons/StorefrontOutlined";
import {
  resolveContextSummary,
  resolveMinimumOrder,
  resolveMovProgress,
  resolveTimeSummary,
} from "./contextSummary";
import { formatMoney } from "../presentation/money";
import { isStorefrontFoundationEnabled } from "../featureFlags";
import { isEnabledFlag } from "../../../checkout-v2/domain/featureFlags";
import "./HomeChrome.css";

export const MinimumOrderMeter = ({ settings, context, cartTotal, language }) => {
  if (isEnabledFlag(settings.is_menu) || settings.show_mov_meter === false) return null;
  const safeCartTotal = Number(cartTotal);
  if (!Number.isFinite(safeCartTotal) || safeCartTotal <= 0) return null;
  if (settings.is_branch_based_ordering && !context.resolved) {
    return null;
  }
  const minimum = resolveMinimumOrder({ settings, context });
  if (!minimum) return null;
  const progress = resolveMovProgress({ minimum, cartTotal: safeCartTotal });
  if (progress.complete) return null;
  const remaining = formatMoney(progress.remaining, { settings, language });
  const current = formatMoney(progress.total, { settings, language });
  const minimumText = formatMoney(progress.minimum, { settings, language });
  const place = context.place ? ` ${language === "arabic" ? "في" : "for"} ${context.place}` : "";
  return (
    <div aria-live="polite" className="f0-mov-meter">
      <div
        aria-label={`${Math.round(progress.progress * 100)}%`}
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={Math.round(progress.progress * 100)}
        className="f0-mov-meter__track"
      >
        <div
          className="f0-mov-meter__fill"
          style={{
            background: settings.dark || "#0099cc",
            width: `${progress.progress * 100}%`,
          }}
        />
      </div>
      <p className="f0-mov-meter__copy">
        {language === "arabic"
          ? `${current} من حد أدنى ${minimumText}${place} — أضف ${remaining}`
          : `${current} of ${minimumText} minimum${place} — add ${remaining}`}
      </p>
    </div>
  );
};

const HomeChrome = ({
  settings = {},
  store = {},
  branch = {},
  address = {},
  cartTotal = 0,
  cart = {},
  deliveryTime = {},
  language = "english",
  onEditContext,
}) => {
  if (isEnabledFlag(settings.is_menu) || !isStorefrontFoundationEnabled(settings)) return null;
  const context = resolveContextSummary({
    store,
    settings,
    branch,
    address,
    language,
  });
  const time = context.resolved ? resolveTimeSummary({ deliveryTime, language, settings, cart,
    branch: (store.branches || []).find(item => String(item.id) === String(branch.branch)),
    fulfillmentType: branch.isPickup || address.selectedDeliveryType === 1 ? "pickup" : "delivery",
  }) : "";
  const selectLabel =
    language === "arabic" ? "اختر طريقة ومكان الطلب" : "Choose method and place";
  return (
    <section
      aria-label={language === "arabic" ? "معلومات الطلب" : "Order context"}
      className="f0-home-chrome"
      dir={language === "arabic" ? "rtl" : "ltr"}
    >
      <button
        aria-label={
          context.resolved
            ? `${context.method}, ${context.place || ""}, ${time}`
            : selectLabel
        }
        className="f0-context-chip"
        onClick={onEditContext}
        type="button"
      >
        <span className="f0-context-chip__icon" aria-hidden="true">
          {context.isPickup ? (
            <StorefrontOutlinedIcon />
          ) : language === "arabic" ? (
            <ArrowBackRoundedIcon />
          ) : (
            <ArrowForwardRoundedIcon />
          )}
        </span>
        <span className="f0-context-chip__content">
          <span className="f0-context-chip__eyebrow">
            {context.resolved ? context.method : selectLabel}
          </span>
          {context.resolved && (
            <span className="f0-context-chip__place">{context.place}</span>
          )}
          <span className="f0-context-chip__time">{time}</span>
        </span>
        <span
          className="f0-context-chip__edit"
          style={{ color: settings.dark || "#0099cc" }}
        >
          {language === "arabic" ? "تعديل" : "Edit"}
        </span>
      </button>
      <MinimumOrderMeter
        cartTotal={cartTotal}
        context={context}
        language={language}
        settings={settings}
      />
    </section>
  );
};

export default HomeChrome;
